module.exports = __webpack_public_path__ + "img/fly.a5c8e686.png";